import React, { useState } from "react";
import { Container, Spacer, Box, Flex, ButtonGroup, Text, Image, Select, HStack, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverHeader, PopoverCloseButton, Portal, Button, PopoverBody, List, ListItem, Menu, MenuButton, MenuList, MenuItem, useDisclosure, Modal, ModalContent, ModalOverlay, ModalHeader, Input, Checkbox, Alert, AlertIcon, position, Avatar } from '@chakra-ui/react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Allroute from "../components/allroute";
import { Link, useNavigate } from 'react-router-dom'
import { CheckIcon, HamburgerIcon } from '@chakra-ui/icons'
import { useDispatch, useSelector } from "react-redux";
import { login } from "../Redux/AuthReducer/action";


export const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [email,setEmail] = useState('')
  const [password,setPassword] = useState('')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isauth = useSelector((store)=>store.Authreducer.isAuth)

const handlesubmit=()=>{
if(email && password){
  dispatch(login({email,password}))
  .then((res)=>{
  navigate('/')
  })
  
}
}
console.log(isauth)


  return (
    <>
      <Flex zIndex={2} position='fixed' w='100%' minWidth='max-content' alignItems='center' gap='2' py={3} px={8} bg='#00B5D8'>

        <Link to='/'>
          <Image w='3cm' src='https://cdn1.tripoto.com/assets/2.9/img/logo/tripoto.svg' alt='abd' />
        </Link>

        <Spacer />
        <HStack spacing={7}>
          <Menu>
            <MenuButton bg='#00B5D8'  >
              <Text color='white' fontWeight='medium'>Actions</Text>
            </MenuButton>
            <MenuList bgColor='white' color='black' w='10cm'>
              <MenuItem>Visit Singapore</MenuItem>
              <MenuItem>Beaches</MenuItem>
              <MenuItem>Mountains</MenuItem>
              <MenuItem>Heritage</MenuItem>
              <MenuItem>Upcoming Festivals</MenuItem>
              <MenuItem>Honeymoon Packages</MenuItem>
            </MenuList>
          </Menu>

          <Text color='white' fontWeight='medium'>Forum</Text>
          <Text color='white' fontWeight='medium'> Pakages</Text>
          <Menu alignItems='center' marginTop='-10px'>
            <MenuButton bg='#00B5D8'>
              <Text color='white' fontWeight='medium'>Publish  Trips</Text>
            </MenuButton>
            <MenuList bgColor='white' color='black'>
              <MenuItem>Create New</MenuItem>
              <MenuItem>Upload photos/Videos</MenuItem>
              <MenuItem>Import Blog</MenuItem>

            </MenuList>
          </Menu>

          {isauth ?<Avatar size='sm'/>:<Text cursor='pointer' color='white' onClick={onOpen} fontWeight='medium'>Login</Text>}
          
          <Modal  blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent px={4} >
             <ModalHeader>Log In !</ModalHeader>
             <Button color='white' bg='blue.500'> Facebook</Button>
             <Button mt={2}>Log in with Google</Button>
             <Text mt={2} align='center'>Or</Text>
            <Input  onChange={(e)=>setEmail(e.target.value)} mt={2} placeholder='Email'></Input>
            <Input onChange={(e)=>setPassword(e.target.value)} mt={2} placeholder='Password'></Input>
            <Box mt={2} justifyContent='space-between'display='flex'>
             <Text mt={2}><Checkbox/> Remember Me</Text> 
             <Text color='blue.400'>Forget Password</Text>
            </Box>
            
              <Button onClick={handlesubmit} mt={2} marginBottom={4} bg='red.500'>Login</Button>
            
           
          </ModalContent>
          </Modal>
        </HStack>
      </Flex>
      <ToastContainer/>
    </>
  )
}